import React from 'react'
import DetailsMovie from './DetailsMovie'
import { useSelector } from 'react-redux'
import MainConatiner from './MainConatiner'
import SecondaryContainer from './SecondaryContainer'

const Togglecompo = () => {
 
  const Movie_fect_id = useSelector((store)=> store?.details?.CardId)
  const showDetails = useSelector((store)=> store.details.showDetails);
  
  return (
    <div>
     
      {!showDetails? 
      (<> <MainConatiner/>
      <SecondaryContainer/></>) : 
      (<>
            <DetailsMovie movie_id={Movie_fect_id}  />
      </>)}
      
    </div>
  )
}

export default Togglecompo